import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, verifyAadharWithOtpV2, generateAadharOtpV2, verifyAadharWithOtpResendV2 } from "../../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { AadharData } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { FaDownload } from 'react-icons/fa';
import { useService } from "../../../context/ServiceContext";

const AadharV2 = () => {
    const [aadharNo, setAadharNo] = useState("");
    const [otp, setOtp] = useState("");
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [aadharDetails, setAadharDetails] = useState({});
    const [otpSent, setOtpSent] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [fwdp, setFwdp] = useState('');
    const [codeVerifier, setCodeVerifier] = useState('');
    const { serviceName } = useService();
    const [resendDisabled, setResendDisabled] = useState(true);
    const [resendTimer, setResendTimer] = useState(30);




    // OTP countdown timer effect
    useEffect(() => {
        if (otpSent) {
            setResendDisabled(true);
            setResendTimer(30);
            const timer = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [otpSent]);







    // Fetch Profile Data on Mount
    useEffect(() => {
        async function fetchProfileData() {
            try {
                setIsLoading(true);
                const response = await fetchProfile(); // API call to get profile details
                setProfileData(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching profile data", error);
                showErrorToast("Failed to fetch profile data.");
                setIsLoading(false);
            }
        }
        fetchProfileData();
    }, []);


    // Verhoeff algorithm tables (for Aadhaar checksum)
    const d = [
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
        [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
        [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
        [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
        [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
        [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
        [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
        [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
        [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
    ];

    const p = [
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
        [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
        [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
        [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
        [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
        [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
        [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
    ];

    const inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

    // ✅ Function to validate Aadhaar Number
    function validateAadhaar(aadhaar) {
        aadhaar = aadhaar.trim();

        // Check if 12 digits and starts with 2-9
        if (!/^[2-9]{1}[0-9]{11}$/.test(aadhaar)) {
            return false;
        }

        let c = 0;
        const reversedArray = aadhaar.split('').reverse().map(x => parseInt(x));
        for (let i = 0; i < reversedArray.length; i++) {
            c = d[c][p[i % 8][reversedArray[i]]];
        }
        return c === 0;
    }


    // Validate Aadhar Number
    const validateAadhar = () => {
        const errors = {};

        // Aadhar validation
        if (!validateAadhaar(aadharNo)) {
            errors.aadharNo = "Invalid Aadhaar number. Please enter a valid 12-digit number.";
            //  showErrorToast(errors.aadharNo);
        }

        // OTP validation (only if otpSent is true)
        if (otpSent && (!otp || otp.length !== 6 || isNaN(otp))) {
            errors.otp = "Please enter a valid 6-digit OTP.";
            showErrorToast(errors.otp);
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    // 🔹 For Sending Aadhar OTP
    const handleAadharSubmit = async () => {
        if (!validateAadhar()) return;

        setIsLoading(true);
        try {
            const response = await generateAadharOtpV2({
                api_id: profileData.user_id,
                api_key: profileData.api_key,
                token_id: profileData.token_id,
                methodName: "getotp",
                aadhar: aadharNo,
            });

            const statusCode = response?.status?.code || response?.status;
            const data = response?.data?.data || response?.data;

            if (statusCode === 200 && data) {
       
                setTransactionId(data?.transactionId);
                setFwdp(data?.fwdp);
                setCodeVerifier(data?.codeVerifier);
                setOtpSent(true);

                showSuccessToast(response?.message || "OTP sent successfully, please enter OTP.");
            } else {
                const errorMsg = response?.message || response?.data?.message || response?.error?.message || "Something went wrong";
                showErrorToast(errorMsg);
            }
        } catch (error) {
            console.error("Aadhar OTP error:", error);
            showErrorToast("Failed to send OTP. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    const handleSubmit = async () => {
        if (!validateAadhar()) return;

        setIsLoading(true);
        try {
            const response = await verifyAadharWithOtpV2({
                api_id: profileData.user_id,
                api_key: profileData.api_key,
                token_id: profileData.token_id,
                methodName: "validateotp",
                aadhar: aadharNo,
                otp,
                transactionId: transactionId,
                fwdp,
                codeVerifier,
                shareCode: "1234",
                isSendPdf: true,
            });

            const data = response?.data?.data || response?.data;
            setAadharDetails(data || {});
            showSuccessToast(response?.data?.message || "Aadhar Verified Successfully.");

            setAadharNo('');
            setOtpSent(false);
        } catch (error) {
            const serverMessage = error?.response?.data?.message || error?.response?.message || error?.response?.error?.message || "Aadhaar verification failed";
            showErrorToast(serverMessage);
        } finally {
            setIsLoading(false);
        }
    };



    // 🔹 For Resending OTP
    const SubmitResendOtp = async () => {
        setIsLoading(true);
        try {
            const response = await verifyAadharWithOtpResendV2({
                api_id: profileData.user_id,
                api_key: profileData.api_key,
                token_id: profileData.token_id,
                methodName: "getotp",
                transactionId,
                fwdp,
                aadhar: aadharNo,
            });

            const statusCode = response?.status?.code || response?.status;
            const data = response?.data?.data;

            if (statusCode === 200 && data) {
                setTransactionId(data?.transactionId);
                setFwdp(data?.fwdp);
                setOtpSent(true);

                showSuccessToast(response?.message || "OTP sent successfully, please enter OTP.");
            } else {
                const errorMsg = response?.message || response?.data?.message || response?.error?.message || "Something went wrong";
                showErrorToast(errorMsg);
            }
        } catch (error) {
            console.error("Aadhar OTP error:", error);
            showErrorToast("Failed to resend OTP. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />


            {/* Go Back Button */}
            <div className="w-full md:w-auto flex justify-end md:justify-end order-1">
                <Link
                    to="/TestMaster"
                    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-2 py-1 rounded-md font-semibold shadow-md transition duration-300"
                >
                    <span>Go Back</span>
                    <IoArrowBackCircleOutline size={24} />
                </Link>
            </div>
            <div className="flex flex-wrap gap-3 justify-start md:ml-64 ml-0">


                {/* Aadhar Number Input */}
                <div className="w-full md:w-1/6 order-2">
                    <InputWithLabel
                        type="text"
                        label="Aadhar No"
                        placeholder="Enter Aadhar No"
                        maxLength={12}
                        className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
                        name="aadharNo"
                        id="aadharNo"
                        required={true}
                        value={aadharNo}
                        onChange={(e) => setAadharNo(e.target.value.replace(/\D/g, ""))}
                        error={errors.aadharNo}
                    />
                </div>

                {/* Verify Aadhar Button */}
                {!otpSent && (
                    <div className="w-full md:w-auto order-3">
                        <Button
                            type="button"
                            className="text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 hover:from-blue-900 hover:to-blue-400 border-4"
                            id="verifyAadhar"
                            name="verifyAadhar"
                            text="Verify Aadhar"
                            onClick={handleAadharSubmit}
                        />
                    </div>
                )}

                {/* OTP Section */}
                {otpSent && (
                    <>
                        {/* OTP Input */}
                        <div className="w-full md:w-1/6 order-4">
                            <InputWithLabel
                                type="text"
                                label="OTP"
                                placeholder="Enter OTP"
                                maxLength={6}
                                className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
                                name="otp"
                                id="otp"
                                required={true}
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                                error={errors.otp}
                            />

                            {/* Resend OTP Button */}
                            <div className="mt-2">
                                <Button
                                    type="button"
                                    disabled={resendDisabled}
                                    className={`text-white ${resendDisabled
                                            ? 'bg-yellow-400 cursor-not-allowed'
                                            : 'bg-yellow-600 hover:bg-yellow-700'
                                        } shadow-md font-semibold rounded-md px-2 py-1 text-md border-4`}
                                    id="resendOtp"
                                    name="resendOtp"
                                    text={resendDisabled ? `Resend OTP (${resendTimer}s)` : 'Resend OTP'}
                                    onClick={SubmitResendOtp}
                                />
                            </div>
                        </div>

                        {/* Submit OTP Button */}
                        <div className="w-full md:w-auto flex items-end order-5">
                            <Button
                                type="button"
                                className="text-white bg-green-800 shadow-lg bg-gradient-to-r from-green-400 via-green-600 to-green-800 font-semibold rounded-md px-2 py-1 mt-5 hover:from-green-800 hover:to-green-400 border-4"
                                id="submitOtp"
                                name="submitOtp"
                                text="Submit OTP"
                                onClick={handleSubmit}
                            />
                        </div>
                    </>
                )}
            </div>



<div class="max-w-3xl mx-auto p-1 md:p-1 bg-white rounded-3xl shadow-2xl mt-1 border border-gray-200 transition-transform duration-300 hover:scale-[1.01]">
  <h2 class="text-2xl font-extrabold text-center text-gray-900 mb-3 tracking-tight">
    🔐 Aadhaar Verification Steps
  </h2>

  <ol class="list-decimal text-gray-800 space-y-3 pl-6 relative">
    <li class="relative group hover:pl-4 transition-all duration-300">
      <span class="inline-block group-hover:text-blue-600 transition-colors duration-300">
        Enter your <span class="font-medium text-gray-900">12-digit Aadhaar number</span> carefully.
      </span>
    </li>
    <li class="relative group hover:pl-4 transition-all duration-300">
      <span class="inline-block">
        Click on <span class="font-semibold text-blue-600 underline underline-offset-2 group-hover:text-blue-800 transition-colors duration-300">“Send OTP”</span> to receive a One-Time Password (OTP) on your registered mobile number.
      </span>
    </li>
    <li class="relative group hover:pl-4 transition-all duration-300">
      <span class="inline-block group-hover:text-blue-600 transition-colors duration-300">
        Enter the OTP correctly in the provided field.
      </span>
    </li>
    <li class="relative group hover:pl-4 transition-all duration-300">
      <span class="inline-block">
        Click on <span class="font-semibold text-green-600 underline underline-offset-2 group-hover:text-green-800 transition-colors duration-300">“Verify OTP”</span> to validate and fetch your Aadhaar details.
      </span>
    </li>
     <li class="hover:text-blue-600 transition duration-300">
        If OTP is not received, wait for a moment and click
        <span class="text-blue-600 font-medium underline underline-offset-2 hover:text-blue-800">“Resend OTP”</span>.
      </li>
  </ol>

  <div class="mt-6 border-t border-gray-300 pt-1">
    <h3 class="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2">
      📌 Important Notes
      <span class="text-yellow-500 animate-pulse text-lg">⚠️</span>
    </h3>
    <ul class="list-disc text-gray-700 space-y-2 pl-6">
      <li class="hover:text-blue-600 transition duration-300">
        Ensure the mobile number linked to your Aadhaar is active.
      </li>
      <li class="hover:text-blue-600 transition duration-300">
        Do not refresh the page during the verification process.
      </li>
      <li class="hover:text-blue-600 transition duration-300">
        Your Aadhaar number is confidential — handle it securely.
      </li>
      <li class="hover:text-blue-600 transition duration-300">
        OTP is valid only for a limited time (usually 5 minutes).
      </li>
      <li class="hover:text-blue-600 transition duration-300">
        If OTP is not received, wait for a moment and click
        <span class="text-blue-600 font-medium underline underline-offset-2 hover:text-blue-800">“Resend OTP”</span>.
      </li>
    </ul>
  </div>
</div>


            {/* Aadhaar Details Card */}
            {aadharDetails && Object.keys(aadharDetails).length > 0 && (
                <>
                    <div className="flex justify-center">
                        <h2 className="font-bold text-2xl mt-4">Aadhar Details</h2>
                    </div>
                    <div className="flex justify-end">
                        <Link className='px-1 flex items-center gap-1 py-1 bg-blue-800 rounded-md text-white font-bold' to={aadharDetails.pdfLink}><FaDownload /> Download Aadhar</Link>
                    </div>
                    <div className="border border-gray-300 rounded-lg p-4 mt-1 flex justify-center shadow-inner shadow-blue-600">
                        {/* Profile Photo */}

                        <div className="w-[16%] md:w-[12%]">
                            <img
                                src={
                                    aadharDetails?.image
                                        ? `data:image/jpeg;base64,${aadharDetails?.image}`
                                        : "/path/to/default-placeholder.png"
                                }
                                alt="Aadhar"
                                className="rounded-lg object-cover w-full h-auto"
                            />

                        </div>

                        {/* Aadhaar Details */}
                        <div className="w-[70%] md:w-[70%] ml-16  grid grid-cols-2 text-lg gap-4 ">
                            {/* Render Specific Details */}
                            <div className="px-2">
                                <span className="font-bold">Name:</span> {aadharDetails?.data?.name || aadharDetails?.name || "N/A"}
                            </div>
                            <div className="px-2">
                                <span className="font-bold">Aadhaar Number:</span>{" "}
                                {aadharDetails?.adharNumber || "N/A"}
                            </div>
                            <div className="px-2">
                                <span className="font-bold">Masked Aadhaar Number:</span>{" "}
                                {aadharDetails?.maskedAdharNumber || "N/A"}
                            </div>
                            <div className="px-2">
                                <span className="font-bold">Date of Birth:</span>{" "}
                                {aadharDetails?.dob
                                    ? new Intl.DateTimeFormat("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    }).format(new Date(aadharDetails?.dob))
                                    : "N/A"}
                            </div>

                            <div className="px-2">
                                <span className="font-bold">Gender:</span>
                                {aadharDetails?.gender === 'M' ? 'Male' :
                                    aadharDetails?.gender === 'F' ? 'Female' : 'N/A'}
                            </div>

                            <div className="px-2">
                                <span className="font-bold">Care Of:</span> {aadharDetails?.careOf || "N/A"}
                            </div>
                            <div className="px-2">
                                {aadharDetails?.address ? (
                                    <>
                                        <div>
                                            <span className="font-bold">House:</span>{" "}
                                            {[
                                                aadharDetails?.address?.house,
                                            ]
                                                .filter(Boolean)
                                                .join(", ")}
                                        </div>
                                    </>
                                ) : (
                                    "N/A"
                                )}
                            </div>
                            <div className="col-span-2 shadow-inner px-2">
                                {aadharDetails?.address ? (
                                    <>
                                        <div>
                                            <span className="font-bold">Address:</span>{" "}
                                            {[
                                                aadharDetails?.address?.house,
                                                aadharDetails?.address?.street,
                                                aadharDetails?.address?.landmark,
                                                aadharDetails?.address?.loc,
                                                aadharDetails?.address?.dist,
                                                aadharDetails?.zip,
                                            ]
                                                .filter(Boolean) // Filter out undefined or null values
                                                .join(", ")}
                                        </div>
                                    </>
                                ) : (
                                    "N/A"
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
            {/* API Response Card */}
            {aadharDetails && Object.keys(aadharDetails).length > 0 && (
                <div className="border border-gray-300 rounded-lg p-1 mt-2 shadow-inner shadow-blue-800">
                    <h2 className="text-2xl font-bold mb-2 text-center">API Response</h2>
                    <pre className="bg-slate-100 p-1 rounded-md overflow-auto text-green-600">
                        {JSON.stringify(aadharDetails, null, 2)}
                    </pre>
                </div>
            )}
        </>
    );
};

export default AadharV2;  